@let requests = loadedRequests!();
@let isLoading = !!(isLoading$ | async);
@let selectedRequestsCount = $selectedRequestsCountComputed!();
@let desktopTableColumns = $desktopTableColumns();
@let rowsSettings = $desktopTableRowsSettings();

@if ($listOfflineState() === 'snapshot') {
  <div class="mx-5 mb-3 rounded-lg bg-amber-100 px-4 py-3 text-amber-900">
    {{ 'offline.snapshot_message' | translate: { date: formatSnapshotTime() } }}
  </div>
} @else if ($listOfflineState() === 'unavailable') {
  <div class="mx-5 mb-3 rounded-lg bg-red-100 px-4 py-3 text-red-900">
    {{ 'offline.unavailable_message' | translate }}
  </div>
}

@if (deviceService.isDesktop$ | async) {
  <tui-loader
    [overlay]="true"
    [loading]="isLoading"
    [inheritColor]="true"
    size="l"
  >
    <section class="x-white w-full">
      <x-alternative-requests-widget
        class="mx-5 mt-4 block"
        [isMobile]="false"
      />
      <x-request-list-filters-buttons
        class="mx-5"
        [$filterIsActive]="$filterIsActive()"
        [$showAssignedToMeFilter]="$canShowAssignedToMeFilter()"
        [$assignedToMeFilterIsActive]="$assignedToMeFilterIsActive()"
        [$hideCompletedRequestsFilterIsActive]="
          $hideCompletedRequestsFilterIsActive()
        "
        [$inWorkRequestsFilterIsActive]="$inWorkRequestsFilterIsActive()"
        [$todayRequestsFilterIsActive]="$todayRequestsFilterIsActive()"
        [$tomorrowRequestsFilterIsActive]="$tomorrowRequestsFilterIsActive()"
        (hideCompletedOutput)="hideCompletedRequests($event)"
        (assignedToMeOutput)="showAssignedToMeRequests($event)"
        (showInWork)="showInWorkRequests($event)"
        (showToday)="showTodayRequests($event)"
        (showTomorrow)="showTomorrowRequests($event)"
        (clearFiltersOutput)="clearFilters()"
        (searchRequestsOutput)="searchRequests()"
        [$contractorFilterIsActive]="$contractorFilterIsActive()"
        [$ownerFilterIsActive]="$ownerFilterIsActive()"
        (openContractorFilter)="openContractorFilterDialog()"
        (openOwnerFilter)="openOwnerFilterDialog()"
        (clearContractorFilter)="clearContractorFilter()"
        (clearOwnerFilter)="clearOwnerFilter()"
        (removeAdditionalFilter)="removeAdditionalFilter($event)"
        (toggleDesktopFiltersModal)="
          openDesktopAdditionalFiltersModal(desktopAdditionalFiltersModal)
        "
        (tableSettingsChanged)="onTableSettingsChangedOutput($event)"
        [$isMobile]="false"
        [desktopTableColumns]="desktopTableColumns"
        [tuiSkeleton]="isLoading && isInitialLoad"
      />
      <div class="flex items-center gap-3 ms-5 mb-2 h-[32px]">
        <p class="x-font-body-4 inline-block">
          Найдено заявок: {{ loadedRequestsCount!() }}
        </p>
        <p
          class="x-font-body-4 inline-block"
          [tuiSkeleton]="isLoading && isInitialLoad"
        >
          @if (selectedRequestsCount) {
            {{ 'requests_list.selected_requests' | translate }}
            <b>{{ selectedRequestsCount }}</b>
          }
        </p>
        @if (atLeastOneRequestSelected!()) {
          <button
            appearance="primary"
            tuiButton
            type="button"
            class="self-end w-[179px] h-[32px]!"
            size="s"
            [disabled]="isLoading || $isReadOnly()"
            (click)="openDesktopGroupActions(desktopGroupActionsTemplate)"
          >
            <span class="x-font-body-4-bold">{{
              'requests_list.edit_requests' | translate
            }}</span>
          </button>
        }
        @if ($canCreateRequests()) {
          <button
            appearance="primary"
            tuiButton
            type="button"
            class="self-end h-[32px]!"
            size="s"
            [disabled]="isLoading || $isReadOnly()"
            (click)="openCreateRequestDialog()"
          >
            <span class="x-font-body-4-bold">{{
              'request_create.create_button' | translate
            }}</span>
          </button>
        }
      </div>
      <div>
        <table
          tuiTable
          class="white-table"
          [tuiSkeleton]="isLoading && isInitialLoad"
          [ngClass]="{ 'h-full': isLoading && isInitialLoad }"
          [columns]="desktopTableColumns"
        >
          <thead tuiThead>
            <tr
              [tuiSkeleton]="isLoading && isInitialLoad"
              x-request-list-columns-filters
              [selectAllRequestsInput]="$selectAllRequests!()!"
              [clearFilters$]="clearFilters$"
              [desktopTableColumns]="desktopTableColumns"
              [desktopTableColumnsWidths]="$desktopTableColumnsWidths()"
              (emitSearch)="searchRequests()"
              (filterChangedOutput)="onColumnFilterChanged($event)"
              (filterIsActiveOutput)="onFilterIsActiveOutput($event)"
              (selectAllRequestsEventOutput)="
                onSelectAllRequestsChildEvent($event)
              "
              (tableSettingsChanged)="onTableSettingsChangedOutput($event)"
            ></tr>
          </thead>
          <tbody tuiTbody [data]="desktopTableColumns">
            @for (request of loadedRequests!(); track request.id) {
              <tr
                (click)="onAuxClick($event, request)"
                (auxclick)="onAuxClick($event, request)"
                [tuiSkeleton]="isLoading && isInitialLoad"
                x-request-list-item-desktop
                [request]="request"
                (selectRequestEvent)="onSelectRequestChildEvent($event)"
                class="cursor-pointer row-colored-by-status"
                [style.--hover-color]="
                  hexToRgba(request.statusId?.color!, 0.3) || ''
                "
                [style.--status-bg-color]="
                  rowsSettings.rowBgColorStatus
                    ? hexToRgba(request.statusId?.color!, 0.2)
                    : ''
                "
                [desktopTableColumns]="desktopTableColumns"
                [isRepossessionMode]="$isRepossessionMode()"
              ></tr>
            } @empty {
              <tr id="desktop-not-found-tr">
                <td colspan="100%" tuiTd>
                  <x-empty-block
                    [title]="'requests_list.nothing_found_matching' | translate"
                  />
                </td>
              </tr>
            }
          </tbody>
        </table>

        <!-- Пагинация — обычный блок ПОСЛЕ таблицы! В футере таблицы x-table-pagination - это невалидный тег!!!-->
        <div
          class="h-[100px] flex items-center desktop-width-limit mx-auto w-max"
        >
          <x-table-pagination
            [limit]="limit"
            [currentPage]="page"
            (setPageEvent)="onPageChangeEvent($event)"
            (setLimitEvent)="onLimitChangeEvent($event)"
            [tuiSkeleton]="isLoading && isInitialLoad"
            class="ms-5"
          />
        </div>
      </div>
    </section>
  </tui-loader>
} @else {
  <div
    class="x-card x-card_size_m"
    [ngClass]="{
      'mb-(--x-footer-height)': atLeastOneRequestSelected!(),
    }"
  >
    <section class="flex mb-4 items-center">
      <input
        tuiCheckbox
        type="checkbox"
        class="ms-2"
        [disabled]="isLoading || $isReadOnly()"
        tuiCheckbox
        [ngModel]="$selectAllRequests!()"
        (ngModelChange)="onSelectAllRequestsChildEvent($event)"
        size="m"
      />
      <p class="typo-body-m ms-3">
        @if (selectedRequestsCount) {
          {{ 'columns_filters.requests_selected_count' | translate }}
          <b>{{ selectedRequestsCount }}</b>
        } @else {
          {{ 'columns_filters.select_all_requests' | translate }}
        }
      </p>
    </section>
    <x-request-list-filters-buttons
      [$filterIsActive]="$filterIsActive()"
      [$showAssignedToMeFilter]="$canShowAssignedToMeFilter()"
      [$assignedToMeFilterIsActive]="$assignedToMeFilterIsActive()"
      [$hideCompletedRequestsFilterIsActive]="
        $hideCompletedRequestsFilterIsActive()
      "
      [$inWorkRequestsFilterIsActive]="$inWorkRequestsFilterIsActive()"
      [$todayRequestsFilterIsActive]="$todayRequestsFilterIsActive()"
      [$tomorrowRequestsFilterIsActive]="$tomorrowRequestsFilterIsActive()"
      (hideCompletedOutput)="hideCompletedRequests($event)"
      (assignedToMeOutput)="showAssignedToMeRequests($event)"
      (showInWork)="showInWorkRequests($event)"
      (showToday)="showTodayRequests($event)"
      (showTomorrow)="showTomorrowRequests($event)"
      (clearFiltersOutput)="clearFilters()"
      (searchRequestsOutput)="searchRequests()"
      [$contractorFilterIsActive]="$contractorFilterIsActive()"
      [$ownerFilterIsActive]="$ownerFilterIsActive()"
      (openContractorFilter)="openContractorFilterDialog()"
      (openOwnerFilter)="openOwnerFilterDialog()"
      (clearContractorFilter)="clearContractorFilter()"
      (clearOwnerFilter)="clearOwnerFilter()"
      (toggleMobileFiltersSheet)="toggleMobileFiltersSheet()"
      (removeAdditionalFilter)="removeAdditionalFilter($event)"
      [$isMobile]="true"
      class="mb-4"
    />
    @if ($canCreateRequests()) {
      <button
        appearance="primary"
        tuiButton
        type="button"
        class="mb-4 w-full"
        size="m"
        data-testid="mobile-create-request-button"
        [disabled]="isLoading || $isReadOnly()"
        (click)="openCreateRequestDialog()"
      >
        {{ 'request_create.create_button' | translate }}
      </button>
    }
    <x-alternative-requests-widget [isMobile]="true" />
    @if ($filterIsActive()) {
      <p class="typo-body-m ms-3 font-extrabold">
        {{ 'requests_list.found' | translate }}:
        <span class="ms-1">{{ requests.length }}</span>
      </p>
    }
    <tui-loader [overlay]="true" [loading]="isLoading" [inheritColor]="true">
      @for (request of requests; track request.id) {
        <x-request-list-item-mobile
          [request]="request"
          (selectRequestEvent)="onSelectRequestChildEvent($event)"
          class="cursor-pointer"
        ></x-request-list-item-mobile>
      } @empty {
        <div
          class="x-card x-card_size_m x-card_text-align_center x-white mt-4 card-shadow backdrop-blur-lg"
          [tuiSkeleton]="isLoading && isInitialLoad"
        >
          <h6 class="typo-h6">
            {{ 'requests_list.nothing_found_matching' | translate }}
          </h6>
        </div>
      }
    </tui-loader>
    @if (loadedRequestsCount!() > 0) {
      <div
        class="x-card x-card_size_m x-white"
        [tuiSkeleton]="isLoading && isInitialLoad"
      >
        <x-table-pagination
          [limit]="limit"
          [currentPage]="page"
          (setPageEvent)="onPageChangeEvent($event)"
          (setLimitEvent)="onLimitChangeEvent($event)"
        />
      </div>
    }
  </div>
  @if (atLeastOneRequestSelected!()) {
    <footer
      class="md:mx-auto md:container text-center h-(--x-footer-height) text-(--x-color-danger) w-full fixed bottom-[15px]"
    >
      <div
        class="x-card x-card_size_m text-center backdrop-blur-lg bg-(--tui-background-neutral-1)"
      >
        <button
          appearance="primary"
          tuiButton
          type="button"
          class="w-full"
          [disabled]="isLoading || $isReadOnly()"
          (click)="toggleMobileGroupActions()"
        >
          {{ 'requests_list.edit_requests' | translate }}
        </button>
      </div>
    </footer>
  }
}
<!--МОБИЛА-->
<!--ДЕСКТОП-->

<ng-template let-observer [(tuiSheetDialog)]="mobileGroupActionsOpened">
  <x-request-group-actions [viewObserver]="observer" />
</ng-template>

<ng-template let-observer [(tuiSheetDialog)]="mobileFiltersSheetOpened">
  <x-request-list-filters-buttons
    [$filterIsActive]="$filterIsActive()"
    [$showAssignedToMeFilter]="$canShowAssignedToMeFilter()"
    [$assignedToMeFilterIsActive]="$assignedToMeFilterIsActive()"
    [$hideCompletedRequestsFilterIsActive]="
      $hideCompletedRequestsFilterIsActive()
    "
    [$inWorkRequestsFilterIsActive]="$inWorkRequestsFilterIsActive()"
    [$todayRequestsFilterIsActive]="$todayRequestsFilterIsActive()"
    [$tomorrowRequestsFilterIsActive]="$tomorrowRequestsFilterIsActive()"
    (hideCompletedOutput)="hideCompletedRequests($event)"
    (assignedToMeOutput)="showAssignedToMeRequests($event)"
    (showInWork)="showInWorkRequests($event)"
    (showToday)="showTodayRequests($event)"
    (showTomorrow)="showTomorrowRequests($event)"
    (clearFiltersOutput)="clearFilters()"
    (searchRequestsOutput)="searchRequests()"
    [$contractorFilterIsActive]="$contractorFilterIsActive()"
    [$ownerFilterIsActive]="$ownerFilterIsActive()"
    (openContractorFilter)="openContractorFilterDialog()"
    (openOwnerFilter)="openOwnerFilterDialog()"
    (clearContractorFilter)="clearContractorFilter()"
    (clearOwnerFilter)="clearOwnerFilter()"
    (toggleMobileFiltersSheet)="toggleMobileFiltersSheet()"
    (removeAdditionalFilter)="removeAdditionalFilter($event)"
    [$isMobile]="true"
    [$insideSheet]="true"
    [$viewObserver]="observer"
  >
    <x-request-list-columns-filters
      (filterChangedOutput)="onColumnFilterChanged($event)"
      (filterIsActiveOutput)="onFilterIsActiveOutput($event)"
      (selectAllRequestsEventOutput)="onSelectAllRequestsChildEvent($event)"
      (emitSearch)="searchRequests()"
      [clearFilters$]="clearFilters$"
      [selectAllRequestsInput]="$selectAllRequests!()"
    />
  </x-request-list-filters-buttons>
</ng-template>

<ng-template let-observer #desktopGroupActionsTemplate>
  <tui-scrollbar class="max-h-[calc(100dvh-5rem)]!">
    <x-request-group-actions [viewObserver]="observer" />
  </tui-scrollbar>
</ng-template>

<ng-template let-observer #desktopAdditionalFiltersModal>
  <x-request-list-filters-buttons
    [$filterIsActive]="$filterIsActive()"
    [$showAssignedToMeFilter]="$canShowAssignedToMeFilter()"
    [$assignedToMeFilterIsActive]="$assignedToMeFilterIsActive()"
    [$hideCompletedRequestsFilterIsActive]="
      $hideCompletedRequestsFilterIsActive()
    "
    [$inWorkRequestsFilterIsActive]="$inWorkRequestsFilterIsActive()"
    [$todayRequestsFilterIsActive]="$todayRequestsFilterIsActive()"
    [$tomorrowRequestsFilterIsActive]="$tomorrowRequestsFilterIsActive()"
    (hideCompletedOutput)="hideCompletedRequests($event)"
    (assignedToMeOutput)="showAssignedToMeRequests($event)"
    (showInWork)="showInWorkRequests($event)"
    (showToday)="showTodayRequests($event)"
    (showTomorrow)="showTomorrowRequests($event)"
    (clearFiltersOutput)="clearFilters()"
    (searchRequestsOutput)="searchRequests()"
    [$contractorFilterIsActive]="$contractorFilterIsActive()"
    [$ownerFilterIsActive]="$ownerFilterIsActive()"
    (openContractorFilter)="openContractorFilterDialog()"
    (openOwnerFilter)="openOwnerFilterDialog()"
    (clearContractorFilter)="clearContractorFilter()"
    (clearOwnerFilter)="clearOwnerFilter()"
    (removeAdditionalFilter)="removeAdditionalFilter($event)"
    [$isMobile]="true"
    [$insideSheet]="true"
    [$viewObserver]="observer"
  >
    <x-request-list-columns-filters
      (filterChangedOutput)="onColumnFilterChanged($event)"
      (filterIsActiveOutput)="onFilterIsActiveOutput($event)"
      (selectAllRequestsEventOutput)="onSelectAllRequestsChildEvent($event)"
      (emitSearch)="searchRequests()"
      [clearFilters$]="clearFilters$"
      [$insideDialog]="true"
      [selectAllRequestsInput]="$selectAllRequests!()"
    />
  </x-request-list-filters-buttons>
</ng-template>
